import Screen from '../../../../shared/utils/screen';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const ChannelListEventTitleContainer = styled.div<React.CSSProperties>`
  color: ${Colors['text']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${56 * Screen.widthRatio}px;
  line-height: ${64 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export default ChannelListEventTitleContainer;
